import { render } from "./examLogin.vue?vue&type=template&id=3838f44a&scoped=true"
import script from "./examLogin.vue?vue&type=script&lang=js"
export * from "./examLogin.vue?vue&type=script&lang=js"

import "./examLogin.vue?vue&type=style&index=0&id=3838f44a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3838f44a"]])

export default __exports__